import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    options: {
      customProperties: true
    },
    themes: {
      dark: {
        primary: "#191919",
        anchor: "#CCCCCC",
        secondary: "#363636",
        background: "#191919"
      }
    }
  },
  icons: {
    iconfont: "md"
  }
});
